"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderRelease = void 0;
const common_1 = require("../../common");
const models_1 = require("../../setup/models");
const models_2 = require("../../shipment/models");
const sales_order_line_model_1 = require("./sales-order-line.model");
class SalesOrderRelease extends common_1.MongoDocument {
}
exports.SalesOrderRelease = SalesOrderRelease;
//# sourceMappingURL=sales-order-release.model.js.map